"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavFlyoutBanner;
const react_1 = __importDefault(require("react"));
const ImageBanner_1 = __importDefault(require("./ImageBanner/ImageBanner"));
const DuplexBanner_1 = __importDefault(require("./DuplexBanner/DuplexBanner"));
function NavFlyoutBanner(props) {
    if (props.designType === "Image") {
        return react_1.default.createElement(ImageBanner_1.default, Object.assign({}, props));
    }
    if (props.designType === "Duplex") {
        return react_1.default.createElement(DuplexBanner_1.default, Object.assign({}, props));
    }
    // Fallback to DuplexBanner if designType is not recognized
    return null;
}
